const DB_NAME = 'gr8ful-session';
const STORE_NAME = 'auth';
const TOKEN_KEY = 'sessionToken';
const USER_KEY = 'userData';

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE_NAME);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function idbSet(key, value) {
  return openDB().then(db => new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    tx.objectStore(STORE_NAME).put(value, key);
    tx.oncomplete = () => { db.close(); resolve(); };
    tx.onerror = () => { db.close(); reject(tx.error); };
  })).catch(() => {});
}

function idbGet(key) {
  return openDB().then(db => new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly');
    const req = tx.objectStore(STORE_NAME).get(key);
    req.onsuccess = () => { db.close(); resolve(req.result); };
    req.onerror = () => { db.close(); reject(req.error); };
  })).catch(() => null);
}

function idbClear() {
  return openDB().then(db => new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    tx.objectStore(STORE_NAME).clear();
    tx.oncomplete = () => { db.close(); resolve(); };
    tx.onerror = () => { db.close(); reject(tx.error); };
  })).catch(() => {});
}

export async function saveSession(token, user) {
  localStorage.setItem('sessionToken', token);
  localStorage.setItem('mustardSeedlingsUser', JSON.stringify(user));
  await idbSet(TOKEN_KEY, token);
  await idbSet(USER_KEY, user);
}

export async function getSession() {
  let token = localStorage.getItem('sessionToken');
  let user = null;
  try {
    const raw = localStorage.getItem('mustardSeedlingsUser');
    if (raw) user = JSON.parse(raw);
  } catch (_) {}

  // Fallback to IndexedDB if localStorage is missing data
  if (!token) {
    token = await idbGet(TOKEN_KEY);
    if (token) localStorage.setItem('sessionToken', token);
  }
  if (!user) {
    user = await idbGet(USER_KEY);
    if (user) localStorage.setItem('mustardSeedlingsUser', JSON.stringify(user));
  }

  return { token, user };
}

export async function clearSession() {
  localStorage.removeItem('sessionToken');
  localStorage.removeItem('mustardSeedlingsUser');
  await idbClear();
}
